module.exports = __webpack_public_path__ + "img/arrival_13.a80ff7c7.jpg";